import { Injectable, OnInit, Injector } from '@angular/core';
import {ParserService } from '../ws/ws.service';
import {environment} from '../../../../environments/environment';
import {IRoomParser} from './room-parser';
import {IRoomManager} from './room-manager';
import {WsService2} from '../ws/ws.service';
declare var $;
@Injectable()

export class RoomParserService extends ParserService implements IRoomParser{
constructor(ws: WsService2){
       super(ws);
    }
    setRoomManager(r:IRoomManager){
        this.roomManager = r;
    }
    roomManager: IRoomManager
   parseMessage(m){
       switch (m.cmd){
           case "peer": this.onPeer(m); break;
           case "exited": this.onExited(m); break;
           case "onKicked": window.location.href=environment.closeRedirection; break;
           case "raisedHand": this.roomManager.raisedHand(m.who, m.raised); break;
           case "updatePeers": this.updatePeers(m); break;
           case "snapshot": this.onVideoSnapshot(m); break;
        }
   }
   onVideoSnapshot(m) {
    // let media = LZString.decompressFromUTF16(m.media)
    console.log('GOT SNAPSHOT for ', m.name);
    $("#img"+m.from).attr("src", m.media);
    this.roomManager.getPeers()[m.from]['snapshot'] = m.media
  
  console.log('GOT SNAPSHOT', m.media.length)
 
}

  updatePeers(m){
    this.roomManager.updatePeers(m.peers);
  }
   onExited(m){
       this.roomManager.onExited(m.who);
   }
   onPeer(m){
       this.roomManager.onPeer(m.who, m.name, m.me, m.type)
   }
   onJoin(fromMobile, techCheck){
       this.send("join", {"fromMobile": fromMobile, "techCheck": techCheck});
   }
   onConnected(){
       this.roomManager.onConnected();
   }
   sendKick(who){
       this.send("kick", {who: who});
   }
   onDisconnected(){
       this.roomManager.onDisconnected();
   }
   sendGotPeer(who){
       this.send("gotPeer", {callee: who});
   }
   sendRaiseHand(who, raised){
       this.send("raiseHand", {who: who, raised: raised})
   }
   sendBye(){
       this.send("bye");
   }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/room/room-parser.service.ts